/**
 * displayName.js — Helper pour afficher le nom d'un produit en français
 *
 * Stratégie de fallback :
 *   1. ai_metadata.nameFr   (traduit lors de l'analyse IA — préféré)
 *   2. ai_metadata.suggestedName (proposé par IA, en français par défaut)
 *   3. product.name         (nom original, peut être en ES/DE/EN)
 *
 * Utilisé partout où un nom de produit catalogue ou dressing est affiché.
 *
 * Pourquoi pas traduire à la volée :
 *   - Coût : appel IA à chaque render = 100k+ tokens/jour pour rien
 *   - Latence : impossible de traduire en synchrone à l'affichage
 *   - Cohérence : le nom doit être stable entre 2 sessions, sinon trouble
 *
 * Voir Lambda : /analyze-catalog-item écrit nameFr dans ai_metadata.
 */

// v1.12.293 — supporte bilingue : nameEn/nameFr selon la langue passée
export function displayName(product, lang) {
  if (!product) return '';
  const ai = product.ai_metadata || {};
  const isEn = lang === 'en';
  // Priorité 1 : nameEn (EN) ou nameFr (FR) explicite
  if (isEn) {
    if (ai.nameEn && typeof ai.nameEn === 'string' && ai.nameEn.trim()) return ai.nameEn.trim();
    if (ai.suggestedNameEn && typeof ai.suggestedNameEn === 'string' && ai.suggestedNameEn.trim()) return ai.suggestedNameEn.trim();
    // Fallback FR si pas d'EN disponible (anciens articles)
    if (ai.nameFr && typeof ai.nameFr === 'string' && ai.nameFr.trim()) return ai.nameFr.trim();
    if (ai.suggestedName && typeof ai.suggestedName === 'string' && ai.suggestedName.trim()) return ai.suggestedName.trim();
  } else {
    if (ai.nameFr && typeof ai.nameFr === 'string' && ai.nameFr.trim()) return ai.nameFr.trim();
    if (ai.suggestedName && typeof ai.suggestedName === 'string' && ai.suggestedName.trim()) return ai.suggestedName.trim();
  }
  // Dernier recours : nom original
  return product.name || '';
}
